import { useState, useEffect } from 'react';
import { useMobileSettings } from '@projectK/context/MobileContextProvider';
import AppLoader from '@projectK/components/AppLoader';

const ParentsStudentsListMain = (props) => {
  const { isMobile, mobileMode } = useMobileSettings();
  const [component, setComponent] = useState(null);

  useEffect(() => {
    const loadComponent = async () => {
      if (isMobile) {
        const module = await import(
          '../MobileComponents/ParentsStudentsListMob'
        );
        setComponent(() => module.default);
      } else {
        const module = await import('../WebComponents/ParentsStudentsListWeb');
        setComponent(() => module.default);
      }
    };

    loadComponent();
  }, [isMobile]);

  const LoadedComponent = component;
  return component ? (
    <LoadedComponent {...props} mobileMode={mobileMode} />
  ) : (
    <AppLoader />
  );
};

export default ParentsStudentsListMain;
